<!-- Form.svelte -->
<script>
	import {onMount} from 'svelte'
	import {execQuery, execMutation} from '../csql.js'
	import { createEventDispatcher } from 'svelte';
	import {usuario} from '../store.js'

	const dispatch = createEventDispatcher();

	export let item = {}
	export let visible = false

	let loading = false
	let provincias = []

	let formdata = JSON.parse(JSON.stringify(item))

	function submit(){
		if(sanitize()){
			guardar()
			visible=false
			// console.log(formdata)
		}else{
			alert("ERROR, el email no es valido!!!")			
		}
	}

	async function guardar(){
		loading = true
		let data = {
			tabname: 'usuarios', 
			mutation: (formdata && formdata.id && formdata.id>0) ? 'update' : 'insert',
			mutationId: 'id',
			params: formdata
		}
		const res = await execMutation(data)
		loading = false
		if(res && res.success==="OK"){
			dispatch('updated')
		}else{
			alert("ERROR, no se realizo actualizacion!!!")
		}
	}

	function sanitize(){
		if( (formdata["email"] || "").trim() === ""  || (formdata["email"] || "").trim().length<8) return false
		formdata["id"] = formdata["id"]
		formdata["email"] = (formdata["email"] || "").trim().toLowerCase()
		formdata["nombre"] = (formdata["nombre"] || "").trim().toUpperCase()
		formdata["apellido"] = (formdata["apellido"] || "").trim().toUpperCase()
		formdata["cuit"] = (formdata["cuit"] || "0").trim()
		formdata["domicilio"] = (formdata["domicilio"] || "").trim()
		formdata["ciudad"] = (formdata["ciudad"] || "").trim()
		formdata["provincia"] = (formdata["provincia"] || "").trim()
		formdata["codpostal"] = (formdata["codpostal"] || "").trim()
		formdata["telefono"] = (formdata["telefono"] || "").trim()
		formdata["tipo"] = (formdata["tipo"] || "MINO").trim()
		formdata["observ"] = (formdata["observ"] || "").trim()
		formdata["activo"] = formdata["activo"] ? 1 : 0
		formdata["clave"] = (formdata["clave"] || '0').trim()
		return true
	}

	function cancelar(){
		visible=false
		dispatch('close')
	}


	onMount( async () => {
		loading = true 
		let query = `select * from provincias order by id`
		const data = await execQuery({query})
		loading= false
		provincias = data.data[0] || {}
	})

</script>

	<div class="modal">
		<div class="container" style="margin-top:50px;">
			
			<form on:submit|preventDefault={submit}>
				
				<div class="row v-center">
					
					<div class="col-sm-1">&nbsp;</div>
					<div class="col-sm-11 lbl">email</div>
					<div class="col-sm-1">#{formdata.id}</div>
					<div class="col-sm-11"><input type="text" class="w-full" bind:value={formdata.email} readonly={$usuario.tipo!=='ADMIN'}></div>
					
					<div class="col-sm-6 lbl">Nombre</div>
					<div class="col-sm-6 lbl">Apellido</div>
					<div class="col-sm-6"><input type="text" class="w-full" bind:value={formdata.nombre} ></div>
					<div class="col-sm-6"><input type="text" class="w-full" bind:value={formdata.apellido} ></div>
					
					<div class="col-sm-6 lbl">CUIT/DNI</div>
					<div class="col-sm-6 lbl">Telefono</div>
					<div class="col-sm-6"><input type="text" class="w-full" bind:value={formdata.cuit} ></div>
					<div class="col-sm-6"><input type="text" class="w-full" bind:value={formdata.telefono} ></div>

					<div class="col-sm-12 lbl">Domicilio</div>
					<div class="col-sm-12"><input type="text" class="w-full" bind:value={formdata.domicilio} ></div>

					<div class="col-sm-4 lbl">Ciudad</div>
					<div class="col-sm-4 lbl">Prov</div>
					<div class="col-sm-4 lbl">CP</div>
					<div class="col-sm-4"><input type="text" class="w-full" bind:value={formdata.ciudad} ></div>
					<div class="col-sm-4">
						<select class="w-full" bind:value={formdata.provincia}>
							{#each provincias as prov, index}
								<option value="{prov.nombre}">{prov.nombre}</option>
							{/each}
						</select>
					</div>
					<div class="col-sm-4"><input type="text" class="w-full" bind:value={formdata.codpostal} ></div>

					{#if $usuario.tipo==='ADMIN'}
						<div class="col-sm-6 lbl">Tipo</div>
						<div class="col-sm-6 lbl">Activo</div>
						<div class="col-sm-6">
							<select class="w-full" bind:value={formdata.tipo}>
								<option value="MINO">MINO</option>
								<option value="MAYO">MAYO</option>
								<option value="ADMIN">ADMIN</option>
							</select>
						</div>
						<div class="col-sm-6">
							<input type="checkbox" bind:checked={formdata.activo}>
						</div>
					{/if}

					<div class="col-sm-12 lbl">Observ.</div>
					<div class="col-sm-12"><textarea class="w-full" rows=3 bind:value={formdata.observ}></textarea></div>

					<div class="col-sm-2 lbl">Clave</div><div class="col-sm-10">&nbsp;</div>
					<div class="col-sm-2"><input type="text" class="w-full" bind:value={formdata.clave}></div>
					<div class="col-sm-10">HEMOS GENERADO ESTA CLAVE ALEATORIAMENTE, si desea puede cambiarla a su gusto. Gracias!</div>
				
					<div class="col-sm-6 text-center">
						<button type="submit" class="inverse">Guardar&nbsp;&check;</button>
					</div>
					<div class="col-sm-6 text-center">
						<button type="reset" class="" on:click={cancelar}>&Cross;&nbsp;Cancelar</button>
					</div>

				</div>

			</form>
		</div>
	</div>

<style>
	input, select{
		margin:0;
		padding:4px;
	}
	.lbl{
		font-size:0.8em;
		color:#777;
		margin-bottom:-2px;
	}
</style>